import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import React, { useEffect, useState } from "react";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import { plotBackground } from "../../../config/colors";


export default function DomoAngulos() {
  const [verticalReclaimer, setVerticalReclaimer] = useState({
    value: [],
    fecha: [],
    estado: [],
  });
  
  const [horizontalReclaimer, setHorizontalReclaimer] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [horizontalStacker, setHorizontalStacker] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  // Fecha inicial y final
  const [date, setDate] = useState({ start: "19-01-2023", end: "25-01-2023" });

  // Objeto inicial de la peticion
  const initialFetch = {
    idSeccion: 6,
    secuencia: 31,
    ultimo: 0,
    frecuencia: 5,
    dias: 7,
  };

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
    const { data } = await getValoresPeriodo(initialFetch);

    populateVerticalReclaimer(data);
    populateHorizontalReclaimer(data);
    populateHorizontalStacker(data);
      //#endregion
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateVerticalReclaimer(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Ángulo Vertical Reclaimer (f)"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setVerticalReclaimer({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateHorizontalReclaimer(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Ángulo Horizontal Reclaimer (?)"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setHorizontalReclaimer({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateHorizontalStacker(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Ángulo Horizontal Stacker (?)"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setHorizontalStacker({
      fecha: arrFechas,
      value: arrValues,
    });
  }
 
  return (
    <>
       <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil Domo Ángulos"}
            subtitle={"Periodo " + date.start + " - " + date.end}
          >
            {/** -------------------------------- Ángulo Vertical Reclaimer (φ) --------------------------------------- */}
            <Chart.Line
              name="Ángulo Vertical Reclaimer (φ)"
              data={verticalReclaimer.value}
              yAxis={1}
            />

            {/** -------------------------------- Ángulo Horizontal Reclaimer (ϴ) --------------------------------------- */}
            <Chart.Line
              name="Ángulo Horizontal Reclaimer (ϴ)"
              data={horizontalReclaimer.value}
              yAxis={0}
            />

            {/** -------------------------------- Ángulo Horizontal Stacker (ϴ) --------------------------------------- */}
            <Chart.Line
              name="Ángulo Horizontal Stacker (ϴ)"
              data={horizontalStacker.value}
              yAxis={0}
            />

            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={verticalReclaimer.fecha} />

            <Chart.YAxis
              labelSuffix=" °"
              title="Ángulo Horizontal (ϴ), °"
              lineWidth={2}
              lineColor="white"
            />

            <Chart.YAxis
              labelSuffix=""
              title="Ángulo Vertical (φ), °"
              lineWidth={2}
              opposite={true}
              lineColor="white"
            />

            <Chart.Tooltip valueSuffix="" />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
